import type { KeyboardEventHandler } from "react"
import { useState } from "react"
import { useTypedSearchParams } from "react-router-typesafe-routes/dom"

import { Root, useAnalytics } from "../../../../utils"

export const useSearch = () => {
	const { send } = useAnalytics()
	const [{ search: querySearch }, setQP] = useTypedSearchParams(Root)
	const [search, setSearch] = useState(querySearch)

	const reset = () => {
		setSearch("")
		setQP({})
	}

	const onChange = (value: string) => setSearch(value)

	const onKeyDown: KeyboardEventHandler<HTMLDivElement> = event => {
		if (event.key === "Enter") {
			setQP({ search })
			send({ event: "search", search })
		}
	}

	return { value: search, reset, onKeyDown, onChange }
}
